module.exports = __webpack_public_path__ + "img/company-logo.8cfa2a1d.png";